import { render, staticRenderFns } from "./VistaChat.vue?vue&type=template&id=5bf95995&scoped=true"
import script from "./VistaChat.vue?vue&type=script&lang=js"
export * from "./VistaChat.vue?vue&type=script&lang=js"
import style0 from "./VistaChat.vue?vue&type=style&index=0&id=5bf95995&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf95995",
  null
  
)

export default component.exports